import { Box, Card, Paper, SvgIcon } from '@mui/material';
import LocationCityIcon from '@mui/icons-material/LocationCity'; //building
import Tooltip from '@mui/material/Tooltip';
import MDTypography from 'components/MDTypography';
import { useNavigate } from 'react-router-dom';

export const BuildingCard = props => {
  const buildingIcon = LocationCityIcon;
  const navigate = useNavigate();

  const getStyle = value => {
    let style = {
      overflowWrap: 'anywhere',
      textAlign: 'end',
      fontWeight: 'bold',
    };
    if (value >= 85) {
      style.color = '#00A551';
    } else if (value <= 84 && value >= 71) {
      style.color = '#FCB400';
    } else if (value <= 70) {
      style.color = '#BE1E2D';
    } else if (value === 0) {
      style.color = '#4e4e4e';
    }
    return style;
  };

  const handleBuildingClick = () => {
    navigate(`/manage-buildings/${props.id}`);
  };

  return (
    <Card
      onClick={handleBuildingClick}
      sx={{
        // my: 1.5,
        width: {
          xs: '325px',
          '&:hover': {
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            transform: 'translateY(-2px)',
            transition: 'all 0.2s ease-in-out',
          },
          transition: 'all 0.2s ease-in-out',
        },
      }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        ml={1}
        mr={1.25}
        my={-0.5}
        sx={{
          padding: '12px 0px 4px 0px',
        }}>
        <Box className="container">
          <Box
            className="topContainer"
            sx={{
              display: 'flex',
              width: '19.5rem',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              <Paper
                className="sensorStatusIcon"
                color={'white'}
                elevation={1}
                style={{
                  // background: `linear-gradient(160deg, ${StatusColor[status][0]}, ${StatusColor[status][1]}`,
                  background: 'blue',
                }}
                sx={{
                  padding: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '3rem',
                  height: '3rem',
                }}>
                <LocationCityIcon
                  sx={{
                    color: '#fff',
                    scale: '2',
                    '&:hover': {
                      color: '#fffff',
                    },
                  }}
                />
              </Paper>
              <MDTypography
                fontSize={16}
                sx={{
                  overflowWrap: 'anywhere',
                  marginLeft: '1rem',
                  fontWeight: 'bold',
                  color: '#000',
                }}>
                {props.name ? `${props.name}` : props.id}
              </MDTypography>
            </Box>
          </Box>
          <Box sx={{ marginTop: '.5rem', width: '19rem' }}>
            <Tooltip
              title={
                <div style={{ textAlign: 'left' }}>
                  city: {props.city}
                  <br />
                  street: {props.street} <br />
                  devices: {props.devices_count}
                  {/* <br /> Area: {props.area_name} */}
                </div>
              }>
              <MDTypography
                fontSize={14}
                sx={{
                  fontWeight: 'regular',
                  color: '#000',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  marginLeft: '',
                }}>
                <>
                  <div>Country: {props.country || 'undefined'}</div>
                  <div>City: {props.city || 'undefined'}</div>
                  <div>Street: {props.street || 'undefined'}</div>
                  <div>Devices: {props.devices_count || 'undefined'}</div>
                </>
              </MDTypography>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '7px',
        }}></Box>
    </Card>
  );
};

export default BuildingCard;
